export function truncate(text, length, clamp) {
	const node = document.createElement('div');

	clamp = clamp || '...';
	node.innerHTML = text;

	const content = node.textContent;

	return content.length > length ? content.slice(0, length) + clamp : content;
};